import SeletorCustomFormComp from './SeletorCustomFormComp'
export default SeletorCustomFormComp


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/SeletorCustomForm/index.js